import React from 'react';

export const Item = ({
    hasAnimation,
    children,
}: {
    hasAnimation: boolean;
    children: React.ReactNode;
}) => {
    const className = `get-started-interactive-content--item ${
        hasAnimation ? ' get-started-interactive-content--animate-item' : ''
    }`;

    return <div className={className}>{children}</div>;
};

export const AttributionPositioner = ({ children }: { children: React.ReactNode }) => (
    <span className="get-started-interactive-content--attribution-positioner">{children}</span>
);

export const ItemCard = ({ children }: { children: React.ReactNode }) => (
    <span className="get-started-interactive-content--item-card">{children}</span>
);

export const ItemLabel = ({
    htmlFor,
    children,
}: {
    htmlFor: string;
    children: React.ReactNode;
}) => <label htmlFor={htmlFor}>{children}</label>;

interface ItemInputProps {
    type: string;
    name: string;
    value: string;
    id: string;
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ItemInput = ({ type, name, value, id, checked, onChange }: ItemInputProps) => (
    <input type={type} name={name} value={value} id={id} checked={checked} onChange={onChange} />
);
